import React from "react";
import { Link } from "react-router-dom";

import GreenLogo from "../Innovators/GreenLogo";

const HomeFooter = () => {
  return (
    <footer className="no-fix">
      <ul className="footer-all-links">
        <div className="copyright">
          <div className="nav-logo-alt">
            <GreenLogo />
          </div>
          <i className="fas fa-trademark mx-10 green"></i>2026
        </div>
        <Link to="/about">
          <li className="footer-link green">About ime</li>
        </Link>
        <Link to="/advertising">
          <li className="footer-link green">Advertising</li>
        </Link>
        <Link to="/calendar">
          <li className="footer-link green">Calendar</li>
        </Link>
        <Link to="/faq">
          <li className="footer-link green">FAQ</li>
        </Link>
        <Link to="/terms">
          <li className="footer-link green">Terms of Agreement</li>
        </Link>
        <Link to="/privacypolicy">
          <li className="footer-link green">Privacy Policy</li>
        </Link>
        <Link to="/cookiepolicy">
          <li className="footer-link green">Cookie Policy</li>
        </Link>
      </ul>
    </footer>
  );
};

export default HomeFooter;
